module.exports = __webpack_public_path__ + "static/7289b233af6ec838e0a8543924a70a4e.svg";